var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBackButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "#EAF4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.001 33.9438C35.2939 34.2367 35.2939 34.7115 35.001 35.0044C34.7081 35.2973 34.2333 35.2973 33.9404 35.0044L27.999 29.0631L22.0577 35.0044C21.7648 35.2973 21.2899 35.2973 20.997 35.0044C20.7041 34.7115 20.7041 34.2367 20.997 33.9438L26.9384 28.0024L20.9976 22.0616C20.7047 21.7687 20.7047 21.2938 20.9976 21.0009C21.2905 20.708 21.7653 20.708 22.0582 21.0009L27.999 26.9417L33.9398 21.0009C34.2327 20.708 34.7076 20.708 35.0005 21.0009C35.2934 21.2938 35.2934 21.7687 35.0005 22.0616L29.0597 28.0024L35.001 33.9438Z",
    fill: "#1B1D1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBackButton);
export default __webpack_public_path__ + "static/media/close-back-button.546040bf564d93e83ef46f9533680f45.svg";
export { ForwardRef as ReactComponent };